(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('AppraisalReportHeaderController', AppraisalReportHeaderController);

    AppraisalReportHeaderController.$inject = ['$rootScope', 'report', 'order', 'account', 'reportEditable', 'reportSubmittable', 'ReportBuilderNav'];

    function AppraisalReportHeaderController($rootScope, report, order, account, reportEditable, reportSubmittable, ReportBuilderNav) {
        var vm = this;
        vm.report = report;
        vm.order = order;
        vm.reportEditable = reportEditable;
        vm.reportSubmittable = reportSubmittable;
        vm.isCosigner = account.appraiserUser && report.cosignerId === account.appraiserUser.id;

        // A Gnowise AVM is delivered as a finished PDF with no dynamic form and no assigned appraiser, so
        // the builder and message board tabs below lead nowhere useful. Same derivation as
        // AppraisalReportReviewController: `order` here is findOneDisplay's DTO, which carries the flag.
        vm.isPdfOnlyReport = !!(order && order.gnowiseAvm === true);
        var address = order.address;
        vm.orderAddress = [address.address1, address.cityName, address.provinceName].filter(Boolean).join(', ');

        // Where Build Appraisal Report goes — the rule is shared with the message board.
        var destination = ReportBuilderNav.destination(order, report);
        vm.isValiqueBuilt = destination === 'VALIQUE';
        vm.hasBuilderReport = destination === 'BUILDER';

        vm.openingValique = false;
        vm.openInValique = openInValique;

        function openInValique(event) {
            if (event) {
                event.preventDefault();
            }
            if (vm.openingValique) {
                return;
            }
            vm.openingValique = true;
            ReportBuilderNav.openInValique(report.id).catch(function() {
                vm.openingValique = false;
            });
        }
    }
})();
